import { Button, Typography } from '@material-ui/core'
import { useParams } from 'react-router-dom'

import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { BookingDetail } from '../../types/bookingDetails'
import useStyles from './styles/index.styles'

type HeaderProps = {
  data: BookingDetail | undefined
  bookingDetail: BookingDetail | undefined
}

const Header = ({ data }: HeaderProps) => {
  const classes = useStyles()
  const params = useParams<{ reservationNumber: string }>()

  return (
    <>
      <div className={classes.header}>
        <div className={classes.herderTitle}>
          <Typography variant="h4" className={classes.headerTitle}>
            {getTranslate('Booking Details')}
          </Typography>
        </div>
        <div className={classes.pmsEvent}>
          <Button
            variant="contained"
            color="secondary"
            disabled={data?.basicDetails.pmsStatus !== 'Confirmed'}
            className={classes.confirmBtn}
            component={LocalizedLink}
            to={`/vouherPdf/${params.reservationNumber}`}>
            <Typography variant="h4" className={classes.whiteText}>
              {getTranslate('Get Confirmation')}
            </Typography>
          </Button>
        </div>
      </div>
    </>
  )
}

export default Header
